import classNames from "classnames"

import LogoMarquee from "./LogoMarquee"
import type { MarqueeLogo } from "./LogoMarquee"
import LayoutItem from "../Layouts/LayoutItem"

import Callout from "@components/elements/V2/Callout"
import Section from "@components/elements/V2/Section"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type LogoShowCaseProps = {
  title?: string
  logos: MarqueeLogo[]
  backgroundColor: Color
  rounded?: boolean
  callout?: Storyblok.Callout
  mobileGridOrder?: number
  desktopOrientation?: "horizontal" | "vertical"
}

const LogoShowCase = ({
  title,
  logos,
  backgroundColor,
  rounded = true,
  callout,
  mobileGridOrder,
  desktopOrientation = "vertical",
}: LogoShowCaseProps) => {
  return (
    <LayoutItem
      as={Section}
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "pb-lg -mb-lg relative flex flex-col gap-40 pt-16 md:pt-20 lg:pt-32",
        {
          "rounded-t-xl -mt-xl": rounded,
          "sm:grid sm:grid-cols-2": desktopOrientation === "horizontal",
        }
      )}
      data-testid="logo-show-case-component"
      mobileGridOrder={mobileGridOrder}
    >
      <div
        className={classNames(
          "flex flex-row flex-wrap items-center gap-x-16 gap-y-8 pb-10",
          {
            "md:pb-12": desktopOrientation === "vertical",
            "sm:pb-0": desktopOrientation === "horizontal",
          }
        )}
      >
        {callout && (
          <Callout
            color={getAccentColor(backgroundColor)}
            text={callout.text}
            textSize={
              desktopOrientation === "horizontal" ? "body-lg" : "body-md"
            }
            highlightedWord={callout.highlightedWord}
            highlightColor={callout.highlightColor}
            hasBorder={callout.hasBorder}
            hasIcon={callout.hasIcon}
            ctaText={callout.ctaText}
            ctaLink={storyblokLinkToYocoLink(callout.ctaLink)}
          />
        )}
        {title && (
          <Typography
            text={title}
            weight="book"
            font="grotesk"
            size="body-lg"
            color={getAccentColor(backgroundColor)}
          />
        )}
      </div>
      <LogoMarquee logos={logos} backgroundColor={backgroundColor} />
    </LayoutItem>
  )
}

export default LogoShowCase
